import { useTranslation } from 'react-i18next';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import useAdminPermissions from '../../hooks/useAdminPermissions';
import ADMIN_SECTIONS from '../admin/adminSections';
import './UserMenu.css';

/**
 * User authentication menu with login/logout and admin access link.
 *
 * Sprint 2 av Fluxer-migrationen lägger till Steam-login som primärt val
 * ovanför Discord-login, plus en pending-banner när access_status inte är
 * 'active'. Admin-länken visas bara för aktiva användare.
 */
export default function UserMenu() {
  const { t } = useTranslation();
  const { user, isLoggedIn, isPending, isActive, login, loginSteam, logout } = useAuth();
  const perms = useAdminPermissions();
  const hasAdminAccess = ADMIN_SECTIONS.some((s) => s.check(perms));
  const navigate = useNavigate();

  if (!isLoggedIn) {
    return (
      <div className="login-buttons">
        <button className="login-btn login-btn-steam" onClick={loginSteam}>
          Logga in med Steam
        </button>
        <button className="login-btn login-btn-discord" onClick={login}>
          Discord
        </button>
      </div>
    );
  }

  const goToProfile = () => {
    if (user.steam_id) {
      navigate(`/stats/players/${user.steam_id}`);
    }
  };

  // Closed-community-grind: visa pending-banner i menyn när användaren
  // inte är 'active'. Klick → /pending där de kan lösa in invite-kod.
  if (!isActive) {
    return (
      <div className="user-menu">
        <button
          className="pending-pill"
          onClick={() => navigate('/pending')}
          title={t('auth.redeemInviteTitle')}
        >
          {isPending ? 'Väntar godkännande' : 'Åtkomst saknas'}
        </button>
        <button className="logout-btn" onClick={logout}>{t('auth.logout')}</button>
      </div>
    );
  }

  return (
    <div className="user-menu">
      <div
        className={`user-profile-link${user.steam_id ? ' clickable' : ''}`}
        onClick={goToProfile}
        title={user.steam_id ? 'Visa din profil' : ''}
      >
        {user.steam_avatar && (
          <img src={user.steam_avatar} alt="" className="user-avatar" />
        )}
        <span className="user-name">{user.steam_username || user.discord_username || user.username}</span>
      </div>
      {hasAdminAccess && (
        <button className="admin-link-btn" onClick={() => navigate('/webadmin')} title="Admin">
          &#9879;
        </button>
      )}
      <button className="settings-btn" onClick={() => navigate('/profile')} title={t('auth.myProfile')}>
        &#9881;
      </button>
      <button className="logout-btn" onClick={logout}>{t('auth.logout')}</button>
    </div>
  );
}
